<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ this.spec }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="py-0">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting Specialty details.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="py-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-data-table
            :loading="load"
            :headers="headers"
            :items="spec_data"
            :search="search"
            :sort-by="['AMOUNT']"
            :sort-desc="[true]"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, -1],
            }"
            :items-per-page="10"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            item-key="_id"
            show-expand
            loading-text="Loading data..."
            class="elevation-0 col-md-12 m-auto pb-1"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="px-0">
                <SpecCodes :insurance="insurance" :claimID="item._id" />
              </td>
            </template>

            <template v-slot:item.AMOUNT="{ item }">
              {{ '$' + item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import SpecCodes from './SpecCodes.vue';

export default {
  name: 'SpecDetails',
  props: ['value', 'insurance', 'start', 'end', 'spec', 'groups', 'providers', 'locations'],
  components: {
    SpecCodes,
  },
  data() {
    return {
      search: '',
      load: false,
      pagination: '',
      singleExpand: true,
      expanded: [],
      cancelSource: null,
      headers: [
        { text: 'Claim Number', value: '_id' },
        { text: 'Subscriber ID', value: 'SUB_ID' },
        { text: 'Patient Name', value: 'SUB_NAME' },
        { text: 'DOB', value: 'SUB_DOB' },
        { text: 'Servicer Name', value: 'PROVIDER_NAME' },
        { text: 'Start Date', value: 'START_DATE' },
        { text: 'End Date', value: 'END_DATE' },
        { text: 'Amount', value: 'AMOUNT' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      spec_data: [],
    };
  },
  methods: {
    async getSpecClaims() {
      this.load = true;
      this.requestError = false;
      this.spec_data = [];

      const provNums = this.providers;
      const locs = this.locations;

      let providers = [];
      let locations = [];

      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      const url = `/api/specialists/details/${this.insurance}/groups=${this.groups}/providers=${providers}/locations=${locations}/${this.spec}/${this.start}/${this.end}`;
      axios
        .get(url)
        .then((response) => {
          this.spec_data = response.data.data;
          this.load = false;
        })
        .catch(() => {
          this.requestError = true;
          this.load = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async spec() {
      if (this.spec != null && this.spec != 0 && this.spec != '') {
        this.getSpecClaims();
      }
    },
    async insurance() {
      if (this.spec != null && this.spec != 0 && this.spec != '') {
        this.getSpecClaims();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
